import React from "react";
import { Checkbox } from "primereact/checkbox";
import "./style.scss";

export default function CustomCheckBox(props) {
  return <Checkbox {...props} />;
}
